/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as BareRouteImport } from './routes/_bare'
import { Route as ShellRouteImport } from './routes/_shell'
import { Route as BareForgotPasswordRouteImport } from './routes/_bare/forgot-password'
import { Route as BareResetPasswordRouteImport } from './routes/_bare/reset-password'
import { Route as BareSignInRouteImport } from './routes/_bare/sign-in'
import { Route as BareSignUpRouteImport } from './routes/_bare/sign-up'
import { Route as BareVerifyEmailRouteImport } from './routes/_bare/verify-email'
import { Route as BareVerifyPhoneRouteImport } from './routes/_bare/verify-phone'
import { Route as ShellIndexRouteImport } from './routes/_shell/index'
import { Route as ShellSplatRouteImport } from './routes/_shell/$'
import { Route as ShellBankingRouteImport } from './routes/_shell/banking'
import { Route as ShellCompanyRouteImport } from './routes/_shell/company'
import { Route as ShellConnectionsRouteImport } from './routes/_shell/connections'
import { Route as ShellMailroomRouteImport } from './routes/_shell/mailroom'
import { Route as ShellOnboardingRouteImport } from './routes/_shell/onboarding'
import { Route as ShellOrdersRouteImport } from './routes/_shell/orders'
import { Route as ShellPaymentSuccessRouteImport } from './routes/_shell/payment-success'
import { Route as ShellServicesRouteImport } from './routes/_shell/services'
import { Route as BareDevAccountingPreviewRouteImport } from './routes/_bare/dev/accounting-preview'
import { Route as BareDevCompanyDocumentsPreviewRouteImport } from './routes/_bare/dev/company-documents-preview'
import { Route as BareDevDashboardPreviewRouteImport } from './routes/_bare/dev/dashboard-preview'
import { Route as BareDevEinApplicationPreviewRouteImport } from './routes/_bare/dev/ein-application-preview'
import { Route as BareDevFederalTaxListPreviewRouteImport } from './routes/_bare/dev/federal-tax-list-preview'
import { Route as BareDevFederalTaxSubmissionPreviewRouteImport } from './routes/_bare/dev/federal-tax-submission-preview'
import { Route as BareDevFederalTaxWizardPreviewRouteImport } from './routes/_bare/dev/federal-tax-wizard-preview'
import { Route as BareDevMailroomPreviewRouteImport } from './routes/_bare/dev/mailroom-preview'
import { Route as BareDevOnboardingWizardPreviewRouteImport } from './routes/_bare/dev/onboarding-wizard-preview'
import { Route as BareDevOrdersPreviewRouteImport } from './routes/_bare/dev/orders-preview'
import { Route as BareDevPaymentSuccessPreviewRouteImport } from './routes/_bare/dev/payment-success-preview'
import { Route as BareDevPlatformStatusPreviewRouteImport } from './routes/_bare/dev/platform-status-preview'
import { Route as BareDevRaChangePreviewRouteImport } from './routes/_bare/dev/ra-change-preview'
import { Route as BareDevServicesPreviewRouteImport } from './routes/_bare/dev/services-preview'
import { Route as BareDevShareholdersPreviewRouteImport } from './routes/_bare/dev/shareholders-preview'
import { Route as BareDevShellPreviewRouteImport } from './routes/_bare/dev/shell-preview'
import { Route as BareDevSidebarDemoRouteImport } from './routes/_bare/dev/sidebar-demo'
import { Route as BareDevStateFilingsPreviewRouteImport } from './routes/_bare/dev/state-filings-preview'
import { Route as BareDevUiKitRouteImport } from './routes/_bare/dev/ui-kit'
import { Route as BareOauthConsentRouteImport } from './routes/_bare/oauth/consent'
import { Route as BareTaxFormTokenRouteImport } from './routes/_bare/tax-form/$token'
import { Route as ShellAccountConnectedAgentsRouteImport } from './routes/_shell/account/connected-agents'
import { Route as ShellAccountSecurityRouteImport } from './routes/_shell/account/security'
import { Route as ShellAccountSettingsRouteImport } from './routes/_shell/account/settings'
import { Route as ShellAccountingIndexRouteImport } from './routes/_shell/accounting/index'
import { Route as ShellAccountingConnectionsRouteImport } from './routes/_shell/accounting/connections'
import { Route as ShellAccountingContractorsRouteImport } from './routes/_shell/accounting/contractors'
import { Route as ShellAccountingDocumentsRouteImport } from './routes/_shell/accounting/documents'
import { Route as ShellAccountingGeneralLedgerRouteImport } from './routes/_shell/accounting/general-ledger'
import { Route as ShellAccountingQuestionsRouteImport } from './routes/_shell/accounting/questions'
import { Route as ShellAccountingReconciliationRouteImport } from './routes/_shell/accounting/reconciliation'
import { Route as ShellAccountingReportsRouteImport } from './routes/_shell/accounting/reports'
import { Route as ShellAccountingTransactionsRouteImport } from './routes/_shell/accounting/transactions'
import { Route as ShellEinCorrectionIndexRouteImport } from './routes/_shell/ein-correction/index'
import { Route as ShellFederalTaxIndexRouteImport } from './routes/_shell/federal-tax/index'
import { Route as ShellFederalTaxIdRouteImport } from './routes/_shell/federal-tax/$id'
import { Route as ShellOnboardingIndexRouteImport } from './routes/_shell/onboarding/index'
import { Route as ShellOnboardingStepRouteImport } from './routes/_shell/onboarding/$step'
import { Route as ShellStateFilingsIndexRouteImport } from './routes/_shell/state-filings/index'
import { Route as ShellStateFilingsCancelRouteImport } from './routes/_shell/state-filings/cancel'
import { Route as ShellStateFilingsSuccessRouteImport } from './routes/_shell/state-filings/success'
import { Route as ShellStateTaxIndexRouteImport } from './routes/_shell/state-tax/index'
import { Route as ShellStateTaxIdRouteImport } from './routes/_shell/state-tax/$id'
import { Route as ShellStateTaxAnnualReportRouteImport } from './routes/_shell/state-tax/annual-report'
import { Route as ShellStateTaxCancelRouteImport } from './routes/_shell/state-tax/cancel'
import { Route as ShellStateTaxFranchiseTaxRouteImport } from './routes/_shell/state-tax/franchise-tax'
import { Route as ShellStateTaxSuccessRouteImport } from './routes/_shell/state-tax/success'
import { Route as ShellAccountingAccountsIndexRouteImport } from './routes/_shell/accounting/accounts.index'
import { Route as ShellAccountingAccountsAccountIdRouteImport } from './routes/_shell/accounting/accounts.$accountId'
import { Route as ShellRegisteredAgentChangeOrderIdRouteImport } from './routes/_shell/registered-agent/change/$orderId'
import { Route as ShellStateFilingsOrdersIdRouteImport } from './routes/_shell/state-filings/orders/$id'
import { Route as ShellAccountingConnectionsStripeCallbackRouteImport } from './routes/_shell/accounting/connections_.stripe.callback'

const BareRoute = BareRouteImport.update({
  id: '/_bare',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellRoute = ShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => rootRouteImport,
} as any)
const BareForgotPasswordRoute = BareForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => BareRoute,
} as any)
const BareResetPasswordRoute = BareResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => BareRoute,
} as any)
const BareSignInRoute = BareSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => BareRoute,
} as any)
const BareSignUpRoute = BareSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => BareRoute,
} as any)
const BareVerifyEmailRoute = BareVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => BareRoute,
} as any)
const BareVerifyPhoneRoute = BareVerifyPhoneRouteImport.update({
  id: '/verify-phone',
  path: '/verify-phone',
  getParentRoute: () => BareRoute,
} as any)
const ShellIndexRoute = ShellIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellSplatRoute = ShellSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => ShellRoute,
} as any)
const ShellBankingRoute = ShellBankingRouteImport.update({
  id: '/banking',
  path: '/banking',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCompanyRoute = ShellCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => ShellRoute,
} as any)
const ShellConnectionsRoute = ShellConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => ShellRoute,
} as any)
const ShellMailroomRoute = ShellMailroomRouteImport.update({
  id: '/mailroom',
  path: '/mailroom',
  getParentRoute: () => ShellRoute,
} as any)
const ShellOnboardingRoute = ShellOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => ShellRoute,
} as any)
const ShellOrdersRoute = ShellOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPaymentSuccessRoute = ShellPaymentSuccessRouteImport.update({
  id: '/payment-success',
  path: '/payment-success',
  getParentRoute: () => ShellRoute,
} as any)
const ShellServicesRoute = ShellServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => ShellRoute,
} as any)
const BareDevAccountingPreviewRoute =
  BareDevAccountingPreviewRouteImport.update({
    id: '/dev/accounting-preview',
    path: '/dev/accounting-preview',
    getParentRoute: () => BareRoute,
  } as any)
const BareDevCompanyDocumentsPreviewRoute =
  BareDevCompanyDocumentsPreviewRouteImport.update({
    id: '/dev/company-documents-preview',
    path: '/dev/company-documents-preview',
    getParentRoute: () => BareRoute,
  } as any)
const BareDevDashboardPreviewRoute = BareDevDashboardPreviewRouteImport.update({
  id: '/dev/dashboard-preview',
  path: '/dev/dashboard-preview',
  getParentRoute: () => BareRoute,
} as any)
const BareDevEinApplicationPreviewRoute =
  BareDevEinApplicationPreviewRouteImport.update({
    id: '/dev/ein-application-preview',
    path: '/dev/ein-application-preview',
    getParentRoute: () => BareRoute,
  } as any)
const BareDevFederalTaxListPreviewRoute =
  BareDevFederalTaxListPreviewRouteImport.update({
    id: '/dev/federal-tax-list-preview',
    path: '/dev/federal-tax-list-preview',
    getParentRoute: () => BareRoute,
  } as any)
const BareDevFederalTaxSubmissionPreviewRoute =
  BareDevFederalTaxSubmissionPreviewRouteImport.update({
    id: '/dev/federal-tax-submission-preview',
    path: '/dev/federal-tax-submission-preview',
    getParentRoute: () => BareRoute,
  } as any)
const BareDevFederalTaxWizardPreviewRoute =
  BareDevFederalTaxWizardPreviewRouteImport.update({
    id: '/dev/federal-tax-wizard-preview',
    path: '/dev/federal-tax-wizard-preview',
    getParentRoute: () => BareRoute,
  } as any)
const BareDevMailroomPreviewRoute = BareDevMailroomPreviewRouteImport.update({
  id: '/dev/mailroom-preview',
  path: '/dev/mailroom-preview',
  getParentRoute: () => BareRoute,
} as any)
const BareDevOnboardingWizardPreviewRoute =
  BareDevOnboardingWizardPreviewRouteImport.update({
    id: '/dev/onboarding-wizard-preview',
    path: '/dev/onboarding-wizard-preview',
    getParentRoute: () => BareRoute,
  } as any)
const BareDevOrdersPreviewRoute = BareDevOrdersPreviewRouteImport.update({
  id: '/dev/orders-preview',
  path: '/dev/orders-preview',
  getParentRoute: () => BareRoute,
} as any)
const BareDevPaymentSuccessPreviewRoute =
  BareDevPaymentSuccessPreviewRouteImport.update({
    id: '/dev/payment-success-preview',
    path: '/dev/payment-success-preview',
    getParentRoute: () => BareRoute,
  } as any)
const BareDevPlatformStatusPreviewRoute =
  BareDevPlatformStatusPreviewRouteImport.update({
    id: '/dev/platform-status-preview',
    path: '/dev/platform-status-preview',
    getParentRoute: () => BareRoute,
  } as any)
const BareDevRaChangePreviewRoute = BareDevRaChangePreviewRouteImport.update({
  id: '/dev/ra-change-preview',
  path: '/dev/ra-change-preview',
  getParentRoute: () => BareRoute,
} as any)
const BareDevServicesPreviewRoute = BareDevServicesPreviewRouteImport.update({
  id: '/dev/services-preview',
  path: '/dev/services-preview',
  getParentRoute: () => BareRoute,
} as any)
const BareDevShareholdersPreviewRoute =
  BareDevShareholdersPreviewRouteImport.update({
    id: '/dev/shareholders-preview',
    path: '/dev/shareholders-preview',
    getParentRoute: () => BareRoute,
  } as any)
const BareDevShellPreviewRoute = BareDevShellPreviewRouteImport.update({
  id: '/dev/shell-preview',
  path: '/dev/shell-preview',
  getParentRoute: () => BareRoute,
} as any)
const BareDevSidebarDemoRoute = BareDevSidebarDemoRouteImport.update({
  id: '/dev/sidebar-demo',
  path: '/dev/sidebar-demo',
  getParentRoute: () => BareRoute,
} as any)
const BareDevStateFilingsPreviewRoute =
  BareDevStateFilingsPreviewRouteImport.update({
    id: '/dev/state-filings-preview',
    path: '/dev/state-filings-preview',
    getParentRoute: () => BareRoute,
  } as any)
const BareDevUiKitRoute = BareDevUiKitRouteImport.update({
  id: '/dev/ui-kit',
  path: '/dev/ui-kit',
  getParentRoute: () => BareRoute,
} as any)
const BareOauthConsentRoute = BareOauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => BareRoute,
} as any)
const BareTaxFormTokenRoute = BareTaxFormTokenRouteImport.update({
  id: '/tax-form/$token',
  path: '/tax-form/$token',
  getParentRoute: () => BareRoute,
} as any)
const ShellAccountConnectedAgentsRoute =
  ShellAccountConnectedAgentsRouteImport.update({
    id: '/account/connected-agents',
    path: '/account/connected-agents',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellAccountSecurityRoute = ShellAccountSecurityRouteImport.update({
  id: '/account/security',
  path: '/account/security',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAccountSettingsRoute = ShellAccountSettingsRouteImport.update({
  id: '/account/settings',
  path: '/account/settings',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAccountingIndexRoute = ShellAccountingIndexRouteImport.update({
  id: '/accounting/',
  path: '/accounting/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAccountingConnectionsRoute =
  ShellAccountingConnectionsRouteImport.update({
    id: '/accounting/connections',
    path: '/accounting/connections',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellAccountingContractorsRoute =
  ShellAccountingContractorsRouteImport.update({
    id: '/accounting/contractors',
    path: '/accounting/contractors',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellAccountingDocumentsRoute =
  ShellAccountingDocumentsRouteImport.update({
    id: '/accounting/documents',
    path: '/accounting/documents',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellAccountingGeneralLedgerRoute =
  ShellAccountingGeneralLedgerRouteImport.update({
    id: '/accounting/general-ledger',
    path: '/accounting/general-ledger',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellAccountingQuestionsRoute =
  ShellAccountingQuestionsRouteImport.update({
    id: '/accounting/questions',
    path: '/accounting/questions',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellAccountingReconciliationRoute =
  ShellAccountingReconciliationRouteImport.update({
    id: '/accounting/reconciliation',
    path: '/accounting/reconciliation',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellAccountingReportsRoute = ShellAccountingReportsRouteImport.update({
  id: '/accounting/reports',
  path: '/accounting/reports',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAccountingTransactionsRoute =
  ShellAccountingTransactionsRouteImport.update({
    id: '/accounting/transactions',
    path: '/accounting/transactions',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellEinCorrectionIndexRoute = ShellEinCorrectionIndexRouteImport.update({
  id: '/ein-correction/',
  path: '/ein-correction/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellFederalTaxIndexRoute = ShellFederalTaxIndexRouteImport.update({
  id: '/federal-tax/',
  path: '/federal-tax/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellFederalTaxIdRoute = ShellFederalTaxIdRouteImport.update({
  id: '/federal-tax/$id',
  path: '/federal-tax/$id',
  getParentRoute: () => ShellRoute,
} as any)
const ShellOnboardingIndexRoute = ShellOnboardingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShellOnboardingRoute,
} as any)
const ShellOnboardingStepRoute = ShellOnboardingStepRouteImport.update({
  id: '/$step',
  path: '/$step',
  getParentRoute: () => ShellOnboardingRoute,
} as any)
const ShellStateFilingsIndexRoute = ShellStateFilingsIndexRouteImport.update({
  id: '/state-filings/',
  path: '/state-filings/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellStateFilingsCancelRoute = ShellStateFilingsCancelRouteImport.update({
  id: '/state-filings/cancel',
  path: '/state-filings/cancel',
  getParentRoute: () => ShellRoute,
} as any)
const ShellStateFilingsSuccessRoute =
  ShellStateFilingsSuccessRouteImport.update({
    id: '/state-filings/success',
    path: '/state-filings/success',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellStateTaxIndexRoute = ShellStateTaxIndexRouteImport.update({
  id: '/state-tax/',
  path: '/state-tax/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellStateTaxIdRoute = ShellStateTaxIdRouteImport.update({
  id: '/state-tax/$id',
  path: '/state-tax/$id',
  getParentRoute: () => ShellRoute,
} as any)
const ShellStateTaxAnnualReportRoute =
  ShellStateTaxAnnualReportRouteImport.update({
    id: '/state-tax/annual-report',
    path: '/state-tax/annual-report',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellStateTaxCancelRoute = ShellStateTaxCancelRouteImport.update({
  id: '/state-tax/cancel',
  path: '/state-tax/cancel',
  getParentRoute: () => ShellRoute,
} as any)
const ShellStateTaxFranchiseTaxRoute =
  ShellStateTaxFranchiseTaxRouteImport.update({
    id: '/state-tax/franchise-tax',
    path: '/state-tax/franchise-tax',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellStateTaxSuccessRoute = ShellStateTaxSuccessRouteImport.update({
  id: '/state-tax/success',
  path: '/state-tax/success',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAccountingAccountsIndexRoute =
  ShellAccountingAccountsIndexRouteImport.update({
    id: '/accounting/accounts/',
    path: '/accounting/accounts/',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellAccountingAccountsAccountIdRoute =
  ShellAccountingAccountsAccountIdRouteImport.update({
    id: '/accounting/accounts/$accountId',
    path: '/accounting/accounts/$accountId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellRegisteredAgentChangeOrderIdRoute =
  ShellRegisteredAgentChangeOrderIdRouteImport.update({
    id: '/registered-agent/change/$orderId',
    path: '/registered-agent/change/$orderId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellStateFilingsOrdersIdRoute =
  ShellStateFilingsOrdersIdRouteImport.update({
    id: '/state-filings/orders/$id',
    path: '/state-filings/orders/$id',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellAccountingConnectionsStripeCallbackRoute =
  ShellAccountingConnectionsStripeCallbackRouteImport.update({
    id: '/accounting/connections_/stripe/callback',
    path: '/accounting/connections/stripe/callback',
    getParentRoute: () => ShellRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ShellIndexRoute
  '/forgot-password': typeof BareForgotPasswordRoute
  '/reset-password': typeof BareResetPasswordRoute
  '/sign-in': typeof BareSignInRoute
  '/sign-up': typeof BareSignUpRoute
  '/verify-email': typeof BareVerifyEmailRoute
  '/verify-phone': typeof BareVerifyPhoneRoute
  '/$': typeof ShellSplatRoute
  '/banking': typeof ShellBankingRoute
  '/company': typeof ShellCompanyRoute
  '/connections': typeof ShellConnectionsRoute
  '/mailroom': typeof ShellMailroomRoute
  '/onboarding': typeof ShellOnboardingRouteWithChildren
  '/orders': typeof ShellOrdersRoute
  '/payment-success': typeof ShellPaymentSuccessRoute
  '/services': typeof ShellServicesRoute
  '/dev/accounting-preview': typeof BareDevAccountingPreviewRoute
  '/dev/company-documents-preview': typeof BareDevCompanyDocumentsPreviewRoute
  '/dev/dashboard-preview': typeof BareDevDashboardPreviewRoute
  '/dev/ein-application-preview': typeof BareDevEinApplicationPreviewRoute
  '/dev/federal-tax-list-preview': typeof BareDevFederalTaxListPreviewRoute
  '/dev/federal-tax-submission-preview': typeof BareDevFederalTaxSubmissionPreviewRoute
  '/dev/federal-tax-wizard-preview': typeof BareDevFederalTaxWizardPreviewRoute
  '/dev/mailroom-preview': typeof BareDevMailroomPreviewRoute
  '/dev/onboarding-wizard-preview': typeof BareDevOnboardingWizardPreviewRoute
  '/dev/orders-preview': typeof BareDevOrdersPreviewRoute
  '/dev/payment-success-preview': typeof BareDevPaymentSuccessPreviewRoute
  '/dev/platform-status-preview': typeof BareDevPlatformStatusPreviewRoute
  '/dev/ra-change-preview': typeof BareDevRaChangePreviewRoute
  '/dev/services-preview': typeof BareDevServicesPreviewRoute
  '/dev/shareholders-preview': typeof BareDevShareholdersPreviewRoute
  '/dev/shell-preview': typeof BareDevShellPreviewRoute
  '/dev/sidebar-demo': typeof BareDevSidebarDemoRoute
  '/dev/state-filings-preview': typeof BareDevStateFilingsPreviewRoute
  '/dev/ui-kit': typeof BareDevUiKitRoute
  '/oauth/consent': typeof BareOauthConsentRoute
  '/tax-form/$token': typeof BareTaxFormTokenRoute
  '/account/connected-agents': typeof ShellAccountConnectedAgentsRoute
  '/account/security': typeof ShellAccountSecurityRoute
  '/account/settings': typeof ShellAccountSettingsRoute
  '/accounting/connections': typeof ShellAccountingConnectionsRoute
  '/accounting/contractors': typeof ShellAccountingContractorsRoute
  '/accounting/documents': typeof ShellAccountingDocumentsRoute
  '/accounting/general-ledger': typeof ShellAccountingGeneralLedgerRoute
  '/accounting/questions': typeof ShellAccountingQuestionsRoute
  '/accounting/reconciliation': typeof ShellAccountingReconciliationRoute
  '/accounting/reports': typeof ShellAccountingReportsRoute
  '/accounting/transactions': typeof ShellAccountingTransactionsRoute
  '/federal-tax/$id': typeof ShellFederalTaxIdRoute
  '/onboarding/$step': typeof ShellOnboardingStepRoute
  '/state-filings/cancel': typeof ShellStateFilingsCancelRoute
  '/state-filings/success': typeof ShellStateFilingsSuccessRoute
  '/state-tax/$id': typeof ShellStateTaxIdRoute
  '/state-tax/annual-report': typeof ShellStateTaxAnnualReportRoute
  '/state-tax/cancel': typeof ShellStateTaxCancelRoute
  '/state-tax/franchise-tax': typeof ShellStateTaxFranchiseTaxRoute
  '/state-tax/success': typeof ShellStateTaxSuccessRoute
  '/accounting/': typeof ShellAccountingIndexRoute
  '/ein-correction/': typeof ShellEinCorrectionIndexRoute
  '/federal-tax/': typeof ShellFederalTaxIndexRoute
  '/onboarding/': typeof ShellOnboardingIndexRoute
  '/state-filings/': typeof ShellStateFilingsIndexRoute
  '/state-tax/': typeof ShellStateTaxIndexRoute
  '/accounting/accounts/$accountId': typeof ShellAccountingAccountsAccountIdRoute
  '/registered-agent/change/$orderId': typeof ShellRegisteredAgentChangeOrderIdRoute
  '/state-filings/orders/$id': typeof ShellStateFilingsOrdersIdRoute
  '/accounting/accounts/': typeof ShellAccountingAccountsIndexRoute
  '/accounting/connections/stripe/callback': typeof ShellAccountingConnectionsStripeCallbackRoute
}
export interface FileRoutesByTo {
  '/': typeof ShellIndexRoute
  '/forgot-password': typeof BareForgotPasswordRoute
  '/reset-password': typeof BareResetPasswordRoute
  '/sign-in': typeof BareSignInRoute
  '/sign-up': typeof BareSignUpRoute
  '/verify-email': typeof BareVerifyEmailRoute
  '/verify-phone': typeof BareVerifyPhoneRoute
  '/$': typeof ShellSplatRoute
  '/banking': typeof ShellBankingRoute
  '/company': typeof ShellCompanyRoute
  '/connections': typeof ShellConnectionsRoute
  '/mailroom': typeof ShellMailroomRoute
  '/orders': typeof ShellOrdersRoute
  '/payment-success': typeof ShellPaymentSuccessRoute
  '/services': typeof ShellServicesRoute
  '/dev/accounting-preview': typeof BareDevAccountingPreviewRoute
  '/dev/company-documents-preview': typeof BareDevCompanyDocumentsPreviewRoute
  '/dev/dashboard-preview': typeof BareDevDashboardPreviewRoute
  '/dev/ein-application-preview': typeof BareDevEinApplicationPreviewRoute
  '/dev/federal-tax-list-preview': typeof BareDevFederalTaxListPreviewRoute
  '/dev/federal-tax-submission-preview': typeof BareDevFederalTaxSubmissionPreviewRoute
  '/dev/federal-tax-wizard-preview': typeof BareDevFederalTaxWizardPreviewRoute
  '/dev/mailroom-preview': typeof BareDevMailroomPreviewRoute
  '/dev/onboarding-wizard-preview': typeof BareDevOnboardingWizardPreviewRoute
  '/dev/orders-preview': typeof BareDevOrdersPreviewRoute
  '/dev/payment-success-preview': typeof BareDevPaymentSuccessPreviewRoute
  '/dev/platform-status-preview': typeof BareDevPlatformStatusPreviewRoute
  '/dev/ra-change-preview': typeof BareDevRaChangePreviewRoute
  '/dev/services-preview': typeof BareDevServicesPreviewRoute
  '/dev/shareholders-preview': typeof BareDevShareholdersPreviewRoute
  '/dev/shell-preview': typeof BareDevShellPreviewRoute
  '/dev/sidebar-demo': typeof BareDevSidebarDemoRoute
  '/dev/state-filings-preview': typeof BareDevStateFilingsPreviewRoute
  '/dev/ui-kit': typeof BareDevUiKitRoute
  '/oauth/consent': typeof BareOauthConsentRoute
  '/tax-form/$token': typeof BareTaxFormTokenRoute
  '/account/connected-agents': typeof ShellAccountConnectedAgentsRoute
  '/account/security': typeof ShellAccountSecurityRoute
  '/account/settings': typeof ShellAccountSettingsRoute
  '/accounting/connections': typeof ShellAccountingConnectionsRoute
  '/accounting/contractors': typeof ShellAccountingContractorsRoute
  '/accounting/documents': typeof ShellAccountingDocumentsRoute
  '/accounting/general-ledger': typeof ShellAccountingGeneralLedgerRoute
  '/accounting/questions': typeof ShellAccountingQuestionsRoute
  '/accounting/reconciliation': typeof ShellAccountingReconciliationRoute
  '/accounting/reports': typeof ShellAccountingReportsRoute
  '/accounting/transactions': typeof ShellAccountingTransactionsRoute
  '/federal-tax/$id': typeof ShellFederalTaxIdRoute
  '/onboarding/$step': typeof ShellOnboardingStepRoute
  '/state-filings/cancel': typeof ShellStateFilingsCancelRoute
  '/state-filings/success': typeof ShellStateFilingsSuccessRoute
  '/state-tax/$id': typeof ShellStateTaxIdRoute
  '/state-tax/annual-report': typeof ShellStateTaxAnnualReportRoute
  '/state-tax/cancel': typeof ShellStateTaxCancelRoute
  '/state-tax/franchise-tax': typeof ShellStateTaxFranchiseTaxRoute
  '/state-tax/success': typeof ShellStateTaxSuccessRoute
  '/accounting': typeof ShellAccountingIndexRoute
  '/ein-correction': typeof ShellEinCorrectionIndexRoute
  '/federal-tax': typeof ShellFederalTaxIndexRoute
  '/onboarding': typeof ShellOnboardingIndexRoute
  '/state-filings': typeof ShellStateFilingsIndexRoute
  '/state-tax': typeof ShellStateTaxIndexRoute
  '/accounting/accounts/$accountId': typeof ShellAccountingAccountsAccountIdRoute
  '/registered-agent/change/$orderId': typeof ShellRegisteredAgentChangeOrderIdRoute
  '/state-filings/orders/$id': typeof ShellStateFilingsOrdersIdRoute
  '/accounting/accounts': typeof ShellAccountingAccountsIndexRoute
  '/accounting/connections/stripe/callback': typeof ShellAccountingConnectionsStripeCallbackRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_bare': typeof BareRouteWithChildren
  '/_shell': typeof ShellRouteWithChildren
  '/_bare/forgot-password': typeof BareForgotPasswordRoute
  '/_bare/reset-password': typeof BareResetPasswordRoute
  '/_bare/sign-in': typeof BareSignInRoute
  '/_bare/sign-up': typeof BareSignUpRoute
  '/_bare/verify-email': typeof BareVerifyEmailRoute
  '/_bare/verify-phone': typeof BareVerifyPhoneRoute
  '/_shell/$': typeof ShellSplatRoute
  '/_shell/banking': typeof ShellBankingRoute
  '/_shell/company': typeof ShellCompanyRoute
  '/_shell/connections': typeof ShellConnectionsRoute
  '/_shell/mailroom': typeof ShellMailroomRoute
  '/_shell/onboarding': typeof ShellOnboardingRouteWithChildren
  '/_shell/orders': typeof ShellOrdersRoute
  '/_shell/payment-success': typeof ShellPaymentSuccessRoute
  '/_shell/services': typeof ShellServicesRoute
  '/_shell/': typeof ShellIndexRoute
  '/_bare/dev/accounting-preview': typeof BareDevAccountingPreviewRoute
  '/_bare/dev/company-documents-preview': typeof BareDevCompanyDocumentsPreviewRoute
  '/_bare/dev/dashboard-preview': typeof BareDevDashboardPreviewRoute
  '/_bare/dev/ein-application-preview': typeof BareDevEinApplicationPreviewRoute
  '/_bare/dev/federal-tax-list-preview': typeof BareDevFederalTaxListPreviewRoute
  '/_bare/dev/federal-tax-submission-preview': typeof BareDevFederalTaxSubmissionPreviewRoute
  '/_bare/dev/federal-tax-wizard-preview': typeof BareDevFederalTaxWizardPreviewRoute
  '/_bare/dev/mailroom-preview': typeof BareDevMailroomPreviewRoute
  '/_bare/dev/onboarding-wizard-preview': typeof BareDevOnboardingWizardPreviewRoute
  '/_bare/dev/orders-preview': typeof BareDevOrdersPreviewRoute
  '/_bare/dev/payment-success-preview': typeof BareDevPaymentSuccessPreviewRoute
  '/_bare/dev/platform-status-preview': typeof BareDevPlatformStatusPreviewRoute
  '/_bare/dev/ra-change-preview': typeof BareDevRaChangePreviewRoute
  '/_bare/dev/services-preview': typeof BareDevServicesPreviewRoute
  '/_bare/dev/shareholders-preview': typeof BareDevShareholdersPreviewRoute
  '/_bare/dev/shell-preview': typeof BareDevShellPreviewRoute
  '/_bare/dev/sidebar-demo': typeof BareDevSidebarDemoRoute
  '/_bare/dev/state-filings-preview': typeof BareDevStateFilingsPreviewRoute
  '/_bare/dev/ui-kit': typeof BareDevUiKitRoute
  '/_bare/oauth/consent': typeof BareOauthConsentRoute
  '/_bare/tax-form/$token': typeof BareTaxFormTokenRoute
  '/_shell/account/connected-agents': typeof ShellAccountConnectedAgentsRoute
  '/_shell/account/security': typeof ShellAccountSecurityRoute
  '/_shell/account/settings': typeof ShellAccountSettingsRoute
  '/_shell/accounting/connections': typeof ShellAccountingConnectionsRoute
  '/_shell/accounting/contractors': typeof ShellAccountingContractorsRoute
  '/_shell/accounting/documents': typeof ShellAccountingDocumentsRoute
  '/_shell/accounting/general-ledger': typeof ShellAccountingGeneralLedgerRoute
  '/_shell/accounting/questions': typeof ShellAccountingQuestionsRoute
  '/_shell/accounting/reconciliation': typeof ShellAccountingReconciliationRoute
  '/_shell/accounting/reports': typeof ShellAccountingReportsRoute
  '/_shell/accounting/transactions': typeof ShellAccountingTransactionsRoute
  '/_shell/federal-tax/$id': typeof ShellFederalTaxIdRoute
  '/_shell/onboarding/$step': typeof ShellOnboardingStepRoute
  '/_shell/state-filings/cancel': typeof ShellStateFilingsCancelRoute
  '/_shell/state-filings/success': typeof ShellStateFilingsSuccessRoute
  '/_shell/state-tax/$id': typeof ShellStateTaxIdRoute
  '/_shell/state-tax/annual-report': typeof ShellStateTaxAnnualReportRoute
  '/_shell/state-tax/cancel': typeof ShellStateTaxCancelRoute
  '/_shell/state-tax/franchise-tax': typeof ShellStateTaxFranchiseTaxRoute
  '/_shell/state-tax/success': typeof ShellStateTaxSuccessRoute
  '/_shell/accounting/': typeof ShellAccountingIndexRoute
  '/_shell/ein-correction/': typeof ShellEinCorrectionIndexRoute
  '/_shell/federal-tax/': typeof ShellFederalTaxIndexRoute
  '/_shell/onboarding/': typeof ShellOnboardingIndexRoute
  '/_shell/state-filings/': typeof ShellStateFilingsIndexRoute
  '/_shell/state-tax/': typeof ShellStateTaxIndexRoute
  '/_shell/accounting/accounts/$accountId': typeof ShellAccountingAccountsAccountIdRoute
  '/_shell/registered-agent/change/$orderId': typeof ShellRegisteredAgentChangeOrderIdRoute
  '/_shell/state-filings/orders/$id': typeof ShellStateFilingsOrdersIdRoute
  '/_shell/accounting/accounts/': typeof ShellAccountingAccountsIndexRoute
  '/_shell/accounting/connections_/stripe/callback': typeof ShellAccountingConnectionsStripeCallbackRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/verify-phone'
    | '/$'
    | '/banking'
    | '/company'
    | '/connections'
    | '/mailroom'
    | '/onboarding'
    | '/orders'
    | '/payment-success'
    | '/services'
    | '/dev/accounting-preview'
    | '/dev/company-documents-preview'
    | '/dev/dashboard-preview'
    | '/dev/ein-application-preview'
    | '/dev/federal-tax-list-preview'
    | '/dev/federal-tax-submission-preview'
    | '/dev/federal-tax-wizard-preview'
    | '/dev/mailroom-preview'
    | '/dev/onboarding-wizard-preview'
    | '/dev/orders-preview'
    | '/dev/payment-success-preview'
    | '/dev/platform-status-preview'
    | '/dev/ra-change-preview'
    | '/dev/services-preview'
    | '/dev/shareholders-preview'
    | '/dev/shell-preview'
    | '/dev/sidebar-demo'
    | '/dev/state-filings-preview'
    | '/dev/ui-kit'
    | '/oauth/consent'
    | '/tax-form/$token'
    | '/account/connected-agents'
    | '/account/security'
    | '/account/settings'
    | '/accounting/connections'
    | '/accounting/contractors'
    | '/accounting/documents'
    | '/accounting/general-ledger'
    | '/accounting/questions'
    | '/accounting/reconciliation'
    | '/accounting/reports'
    | '/accounting/transactions'
    | '/federal-tax/$id'
    | '/onboarding/$step'
    | '/state-filings/cancel'
    | '/state-filings/success'
    | '/state-tax/$id'
    | '/state-tax/annual-report'
    | '/state-tax/cancel'
    | '/state-tax/franchise-tax'
    | '/state-tax/success'
    | '/accounting/'
    | '/ein-correction/'
    | '/federal-tax/'
    | '/onboarding/'
    | '/state-filings/'
    | '/state-tax/'
    | '/accounting/accounts/$accountId'
    | '/registered-agent/change/$orderId'
    | '/state-filings/orders/$id'
    | '/accounting/accounts/'
    | '/accounting/connections/stripe/callback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/verify-phone'
    | '/$'
    | '/banking'
    | '/company'
    | '/connections'
    | '/mailroom'
    | '/orders'
    | '/payment-success'
    | '/services'
    | '/dev/accounting-preview'
    | '/dev/company-documents-preview'
    | '/dev/dashboard-preview'
    | '/dev/ein-application-preview'
    | '/dev/federal-tax-list-preview'
    | '/dev/federal-tax-submission-preview'
    | '/dev/federal-tax-wizard-preview'
    | '/dev/mailroom-preview'
    | '/dev/onboarding-wizard-preview'
    | '/dev/orders-preview'
    | '/dev/payment-success-preview'
    | '/dev/platform-status-preview'
    | '/dev/ra-change-preview'
    | '/dev/services-preview'
    | '/dev/shareholders-preview'
    | '/dev/shell-preview'
    | '/dev/sidebar-demo'
    | '/dev/state-filings-preview'
    | '/dev/ui-kit'
    | '/oauth/consent'
    | '/tax-form/$token'
    | '/account/connected-agents'
    | '/account/security'
    | '/account/settings'
    | '/accounting/connections'
    | '/accounting/contractors'
    | '/accounting/documents'
    | '/accounting/general-ledger'
    | '/accounting/questions'
    | '/accounting/reconciliation'
    | '/accounting/reports'
    | '/accounting/transactions'
    | '/federal-tax/$id'
    | '/onboarding/$step'
    | '/state-filings/cancel'
    | '/state-filings/success'
    | '/state-tax/$id'
    | '/state-tax/annual-report'
    | '/state-tax/cancel'
    | '/state-tax/franchise-tax'
    | '/state-tax/success'
    | '/accounting'
    | '/ein-correction'
    | '/federal-tax'
    | '/onboarding'
    | '/state-filings'
    | '/state-tax'
    | '/accounting/accounts/$accountId'
    | '/registered-agent/change/$orderId'
    | '/state-filings/orders/$id'
    | '/accounting/accounts'
    | '/accounting/connections/stripe/callback'
  id:
    | '__root__'
    | '/_bare'
    | '/_shell'
    | '/_bare/forgot-password'
    | '/_bare/reset-password'
    | '/_bare/sign-in'
    | '/_bare/sign-up'
    | '/_bare/verify-email'
    | '/_bare/verify-phone'
    | '/_shell/$'
    | '/_shell/banking'
    | '/_shell/company'
    | '/_shell/connections'
    | '/_shell/mailroom'
    | '/_shell/onboarding'
    | '/_shell/orders'
    | '/_shell/payment-success'
    | '/_shell/services'
    | '/_shell/'
    | '/_bare/dev/accounting-preview'
    | '/_bare/dev/company-documents-preview'
    | '/_bare/dev/dashboard-preview'
    | '/_bare/dev/ein-application-preview'
    | '/_bare/dev/federal-tax-list-preview'
    | '/_bare/dev/federal-tax-submission-preview'
    | '/_bare/dev/federal-tax-wizard-preview'
    | '/_bare/dev/mailroom-preview'
    | '/_bare/dev/onboarding-wizard-preview'
    | '/_bare/dev/orders-preview'
    | '/_bare/dev/payment-success-preview'
    | '/_bare/dev/platform-status-preview'
    | '/_bare/dev/ra-change-preview'
    | '/_bare/dev/services-preview'
    | '/_bare/dev/shareholders-preview'
    | '/_bare/dev/shell-preview'
    | '/_bare/dev/sidebar-demo'
    | '/_bare/dev/state-filings-preview'
    | '/_bare/dev/ui-kit'
    | '/_bare/oauth/consent'
    | '/_bare/tax-form/$token'
    | '/_shell/account/connected-agents'
    | '/_shell/account/security'
    | '/_shell/account/settings'
    | '/_shell/accounting/connections'
    | '/_shell/accounting/contractors'
    | '/_shell/accounting/documents'
    | '/_shell/accounting/general-ledger'
    | '/_shell/accounting/questions'
    | '/_shell/accounting/reconciliation'
    | '/_shell/accounting/reports'
    | '/_shell/accounting/transactions'
    | '/_shell/federal-tax/$id'
    | '/_shell/onboarding/$step'
    | '/_shell/state-filings/cancel'
    | '/_shell/state-filings/success'
    | '/_shell/state-tax/$id'
    | '/_shell/state-tax/annual-report'
    | '/_shell/state-tax/cancel'
    | '/_shell/state-tax/franchise-tax'
    | '/_shell/state-tax/success'
    | '/_shell/accounting/'
    | '/_shell/ein-correction/'
    | '/_shell/federal-tax/'
    | '/_shell/onboarding/'
    | '/_shell/state-filings/'
    | '/_shell/state-tax/'
    | '/_shell/accounting/accounts/$accountId'
    | '/_shell/registered-agent/change/$orderId'
    | '/_shell/state-filings/orders/$id'
    | '/_shell/accounting/accounts/'
    | '/_shell/accounting/connections_/stripe/callback'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  BareRoute: typeof BareRouteWithChildren
  ShellRoute: typeof ShellRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_bare': {
      id: '/_bare'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof BareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell': {
      id: '/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ShellRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_bare/forgot-password': {
      id: '/_bare/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof BareForgotPasswordRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/reset-password': {
      id: '/_bare/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof BareResetPasswordRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/sign-in': {
      id: '/_bare/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof BareSignInRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/sign-up': {
      id: '/_bare/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof BareSignUpRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/verify-email': {
      id: '/_bare/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof BareVerifyEmailRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/verify-phone': {
      id: '/_bare/verify-phone'
      path: '/verify-phone'
      fullPath: '/verify-phone'
      preLoaderRoute: typeof BareVerifyPhoneRouteImport
      parentRoute: typeof BareRoute
    }
    '/_shell/': {
      id: '/_shell/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ShellIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/$': {
      id: '/_shell/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof ShellSplatRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/banking': {
      id: '/_shell/banking'
      path: '/banking'
      fullPath: '/banking'
      preLoaderRoute: typeof ShellBankingRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/company': {
      id: '/_shell/company'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof ShellCompanyRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/connections': {
      id: '/_shell/connections'
      path: '/connections'
      fullPath: '/connections'
      preLoaderRoute: typeof ShellConnectionsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/mailroom': {
      id: '/_shell/mailroom'
      path: '/mailroom'
      fullPath: '/mailroom'
      preLoaderRoute: typeof ShellMailroomRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/onboarding': {
      id: '/_shell/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof ShellOnboardingRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/orders': {
      id: '/_shell/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof ShellOrdersRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/payment-success': {
      id: '/_shell/payment-success'
      path: '/payment-success'
      fullPath: '/payment-success'
      preLoaderRoute: typeof ShellPaymentSuccessRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/services': {
      id: '/_shell/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof ShellServicesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_bare/dev/accounting-preview': {
      id: '/_bare/dev/accounting-preview'
      path: '/dev/accounting-preview'
      fullPath: '/dev/accounting-preview'
      preLoaderRoute: typeof BareDevAccountingPreviewRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/dev/company-documents-preview': {
      id: '/_bare/dev/company-documents-preview'
      path: '/dev/company-documents-preview'
      fullPath: '/dev/company-documents-preview'
      preLoaderRoute: typeof BareDevCompanyDocumentsPreviewRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/dev/dashboard-preview': {
      id: '/_bare/dev/dashboard-preview'
      path: '/dev/dashboard-preview'
      fullPath: '/dev/dashboard-preview'
      preLoaderRoute: typeof BareDevDashboardPreviewRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/dev/ein-application-preview': {
      id: '/_bare/dev/ein-application-preview'
      path: '/dev/ein-application-preview'
      fullPath: '/dev/ein-application-preview'
      preLoaderRoute: typeof BareDevEinApplicationPreviewRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/dev/federal-tax-list-preview': {
      id: '/_bare/dev/federal-tax-list-preview'
      path: '/dev/federal-tax-list-preview'
      fullPath: '/dev/federal-tax-list-preview'
      preLoaderRoute: typeof BareDevFederalTaxListPreviewRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/dev/federal-tax-submission-preview': {
      id: '/_bare/dev/federal-tax-submission-preview'
      path: '/dev/federal-tax-submission-preview'
      fullPath: '/dev/federal-tax-submission-preview'
      preLoaderRoute: typeof BareDevFederalTaxSubmissionPreviewRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/dev/federal-tax-wizard-preview': {
      id: '/_bare/dev/federal-tax-wizard-preview'
      path: '/dev/federal-tax-wizard-preview'
      fullPath: '/dev/federal-tax-wizard-preview'
      preLoaderRoute: typeof BareDevFederalTaxWizardPreviewRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/dev/mailroom-preview': {
      id: '/_bare/dev/mailroom-preview'
      path: '/dev/mailroom-preview'
      fullPath: '/dev/mailroom-preview'
      preLoaderRoute: typeof BareDevMailroomPreviewRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/dev/onboarding-wizard-preview': {
      id: '/_bare/dev/onboarding-wizard-preview'
      path: '/dev/onboarding-wizard-preview'
      fullPath: '/dev/onboarding-wizard-preview'
      preLoaderRoute: typeof BareDevOnboardingWizardPreviewRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/dev/orders-preview': {
      id: '/_bare/dev/orders-preview'
      path: '/dev/orders-preview'
      fullPath: '/dev/orders-preview'
      preLoaderRoute: typeof BareDevOrdersPreviewRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/dev/payment-success-preview': {
      id: '/_bare/dev/payment-success-preview'
      path: '/dev/payment-success-preview'
      fullPath: '/dev/payment-success-preview'
      preLoaderRoute: typeof BareDevPaymentSuccessPreviewRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/dev/platform-status-preview': {
      id: '/_bare/dev/platform-status-preview'
      path: '/dev/platform-status-preview'
      fullPath: '/dev/platform-status-preview'
      preLoaderRoute: typeof BareDevPlatformStatusPreviewRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/dev/ra-change-preview': {
      id: '/_bare/dev/ra-change-preview'
      path: '/dev/ra-change-preview'
      fullPath: '/dev/ra-change-preview'
      preLoaderRoute: typeof BareDevRaChangePreviewRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/dev/services-preview': {
      id: '/_bare/dev/services-preview'
      path: '/dev/services-preview'
      fullPath: '/dev/services-preview'
      preLoaderRoute: typeof BareDevServicesPreviewRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/dev/shareholders-preview': {
      id: '/_bare/dev/shareholders-preview'
      path: '/dev/shareholders-preview'
      fullPath: '/dev/shareholders-preview'
      preLoaderRoute: typeof BareDevShareholdersPreviewRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/dev/shell-preview': {
      id: '/_bare/dev/shell-preview'
      path: '/dev/shell-preview'
      fullPath: '/dev/shell-preview'
      preLoaderRoute: typeof BareDevShellPreviewRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/dev/sidebar-demo': {
      id: '/_bare/dev/sidebar-demo'
      path: '/dev/sidebar-demo'
      fullPath: '/dev/sidebar-demo'
      preLoaderRoute: typeof BareDevSidebarDemoRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/dev/state-filings-preview': {
      id: '/_bare/dev/state-filings-preview'
      path: '/dev/state-filings-preview'
      fullPath: '/dev/state-filings-preview'
      preLoaderRoute: typeof BareDevStateFilingsPreviewRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/dev/ui-kit': {
      id: '/_bare/dev/ui-kit'
      path: '/dev/ui-kit'
      fullPath: '/dev/ui-kit'
      preLoaderRoute: typeof BareDevUiKitRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/oauth/consent': {
      id: '/_bare/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof BareOauthConsentRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/tax-form/$token': {
      id: '/_bare/tax-form/$token'
      path: '/tax-form/$token'
      fullPath: '/tax-form/$token'
      preLoaderRoute: typeof BareTaxFormTokenRouteImport
      parentRoute: typeof BareRoute
    }
    '/_shell/account/connected-agents': {
      id: '/_shell/account/connected-agents'
      path: '/account/connected-agents'
      fullPath: '/account/connected-agents'
      preLoaderRoute: typeof ShellAccountConnectedAgentsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/account/security': {
      id: '/_shell/account/security'
      path: '/account/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof ShellAccountSecurityRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/account/settings': {
      id: '/_shell/account/settings'
      path: '/account/settings'
      fullPath: '/account/settings'
      preLoaderRoute: typeof ShellAccountSettingsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/accounting/': {
      id: '/_shell/accounting/'
      path: '/accounting'
      fullPath: '/accounting/'
      preLoaderRoute: typeof ShellAccountingIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/accounting/connections': {
      id: '/_shell/accounting/connections'
      path: '/accounting/connections'
      fullPath: '/accounting/connections'
      preLoaderRoute: typeof ShellAccountingConnectionsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/accounting/contractors': {
      id: '/_shell/accounting/contractors'
      path: '/accounting/contractors'
      fullPath: '/accounting/contractors'
      preLoaderRoute: typeof ShellAccountingContractorsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/accounting/documents': {
      id: '/_shell/accounting/documents'
      path: '/accounting/documents'
      fullPath: '/accounting/documents'
      preLoaderRoute: typeof ShellAccountingDocumentsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/accounting/general-ledger': {
      id: '/_shell/accounting/general-ledger'
      path: '/accounting/general-ledger'
      fullPath: '/accounting/general-ledger'
      preLoaderRoute: typeof ShellAccountingGeneralLedgerRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/accounting/questions': {
      id: '/_shell/accounting/questions'
      path: '/accounting/questions'
      fullPath: '/accounting/questions'
      preLoaderRoute: typeof ShellAccountingQuestionsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/accounting/reconciliation': {
      id: '/_shell/accounting/reconciliation'
      path: '/accounting/reconciliation'
      fullPath: '/accounting/reconciliation'
      preLoaderRoute: typeof ShellAccountingReconciliationRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/accounting/reports': {
      id: '/_shell/accounting/reports'
      path: '/accounting/reports'
      fullPath: '/accounting/reports'
      preLoaderRoute: typeof ShellAccountingReportsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/accounting/transactions': {
      id: '/_shell/accounting/transactions'
      path: '/accounting/transactions'
      fullPath: '/accounting/transactions'
      preLoaderRoute: typeof ShellAccountingTransactionsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/ein-correction/': {
      id: '/_shell/ein-correction/'
      path: '/ein-correction'
      fullPath: '/ein-correction/'
      preLoaderRoute: typeof ShellEinCorrectionIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/federal-tax/': {
      id: '/_shell/federal-tax/'
      path: '/federal-tax'
      fullPath: '/federal-tax/'
      preLoaderRoute: typeof ShellFederalTaxIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/federal-tax/$id': {
      id: '/_shell/federal-tax/$id'
      path: '/federal-tax/$id'
      fullPath: '/federal-tax/$id'
      preLoaderRoute: typeof ShellFederalTaxIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/onboarding/': {
      id: '/_shell/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof ShellOnboardingIndexRouteImport
      parentRoute: typeof ShellOnboardingRoute
    }
    '/_shell/onboarding/$step': {
      id: '/_shell/onboarding/$step'
      path: '/$step'
      fullPath: '/onboarding/$step'
      preLoaderRoute: typeof ShellOnboardingStepRouteImport
      parentRoute: typeof ShellOnboardingRoute
    }
    '/_shell/state-filings/': {
      id: '/_shell/state-filings/'
      path: '/state-filings'
      fullPath: '/state-filings/'
      preLoaderRoute: typeof ShellStateFilingsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/state-filings/cancel': {
      id: '/_shell/state-filings/cancel'
      path: '/state-filings/cancel'
      fullPath: '/state-filings/cancel'
      preLoaderRoute: typeof ShellStateFilingsCancelRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/state-filings/success': {
      id: '/_shell/state-filings/success'
      path: '/state-filings/success'
      fullPath: '/state-filings/success'
      preLoaderRoute: typeof ShellStateFilingsSuccessRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/state-tax/': {
      id: '/_shell/state-tax/'
      path: '/state-tax'
      fullPath: '/state-tax/'
      preLoaderRoute: typeof ShellStateTaxIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/state-tax/$id': {
      id: '/_shell/state-tax/$id'
      path: '/state-tax/$id'
      fullPath: '/state-tax/$id'
      preLoaderRoute: typeof ShellStateTaxIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/state-tax/annual-report': {
      id: '/_shell/state-tax/annual-report'
      path: '/state-tax/annual-report'
      fullPath: '/state-tax/annual-report'
      preLoaderRoute: typeof ShellStateTaxAnnualReportRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/state-tax/cancel': {
      id: '/_shell/state-tax/cancel'
      path: '/state-tax/cancel'
      fullPath: '/state-tax/cancel'
      preLoaderRoute: typeof ShellStateTaxCancelRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/state-tax/franchise-tax': {
      id: '/_shell/state-tax/franchise-tax'
      path: '/state-tax/franchise-tax'
      fullPath: '/state-tax/franchise-tax'
      preLoaderRoute: typeof ShellStateTaxFranchiseTaxRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/state-tax/success': {
      id: '/_shell/state-tax/success'
      path: '/state-tax/success'
      fullPath: '/state-tax/success'
      preLoaderRoute: typeof ShellStateTaxSuccessRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/accounting/accounts/': {
      id: '/_shell/accounting/accounts/'
      path: '/accounting/accounts'
      fullPath: '/accounting/accounts/'
      preLoaderRoute: typeof ShellAccountingAccountsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/accounting/accounts/$accountId': {
      id: '/_shell/accounting/accounts/$accountId'
      path: '/accounting/accounts/$accountId'
      fullPath: '/accounting/accounts/$accountId'
      preLoaderRoute: typeof ShellAccountingAccountsAccountIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/registered-agent/change/$orderId': {
      id: '/_shell/registered-agent/change/$orderId'
      path: '/registered-agent/change/$orderId'
      fullPath: '/registered-agent/change/$orderId'
      preLoaderRoute: typeof ShellRegisteredAgentChangeOrderIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/state-filings/orders/$id': {
      id: '/_shell/state-filings/orders/$id'
      path: '/state-filings/orders/$id'
      fullPath: '/state-filings/orders/$id'
      preLoaderRoute: typeof ShellStateFilingsOrdersIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/accounting/connections_/stripe/callback': {
      id: '/_shell/accounting/connections_/stripe/callback'
      path: '/accounting/connections/stripe/callback'
      fullPath: '/accounting/connections/stripe/callback'
      preLoaderRoute: typeof ShellAccountingConnectionsStripeCallbackRouteImport
      parentRoute: typeof ShellRoute
    }
  }
}

interface BareRouteChildren {
  BareForgotPasswordRoute: typeof BareForgotPasswordRoute
  BareResetPasswordRoute: typeof BareResetPasswordRoute
  BareSignInRoute: typeof BareSignInRoute
  BareSignUpRoute: typeof BareSignUpRoute
  BareVerifyEmailRoute: typeof BareVerifyEmailRoute
  BareVerifyPhoneRoute: typeof BareVerifyPhoneRoute
  BareDevAccountingPreviewRoute: typeof BareDevAccountingPreviewRoute
  BareDevCompanyDocumentsPreviewRoute: typeof BareDevCompanyDocumentsPreviewRoute
  BareDevDashboardPreviewRoute: typeof BareDevDashboardPreviewRoute
  BareDevEinApplicationPreviewRoute: typeof BareDevEinApplicationPreviewRoute
  BareDevFederalTaxListPreviewRoute: typeof BareDevFederalTaxListPreviewRoute
  BareDevFederalTaxSubmissionPreviewRoute: typeof BareDevFederalTaxSubmissionPreviewRoute
  BareDevFederalTaxWizardPreviewRoute: typeof BareDevFederalTaxWizardPreviewRoute
  BareDevMailroomPreviewRoute: typeof BareDevMailroomPreviewRoute
  BareDevOnboardingWizardPreviewRoute: typeof BareDevOnboardingWizardPreviewRoute
  BareDevOrdersPreviewRoute: typeof BareDevOrdersPreviewRoute
  BareDevPaymentSuccessPreviewRoute: typeof BareDevPaymentSuccessPreviewRoute
  BareDevPlatformStatusPreviewRoute: typeof BareDevPlatformStatusPreviewRoute
  BareDevRaChangePreviewRoute: typeof BareDevRaChangePreviewRoute
  BareDevServicesPreviewRoute: typeof BareDevServicesPreviewRoute
  BareDevShareholdersPreviewRoute: typeof BareDevShareholdersPreviewRoute
  BareDevShellPreviewRoute: typeof BareDevShellPreviewRoute
  BareDevSidebarDemoRoute: typeof BareDevSidebarDemoRoute
  BareDevStateFilingsPreviewRoute: typeof BareDevStateFilingsPreviewRoute
  BareDevUiKitRoute: typeof BareDevUiKitRoute
  BareOauthConsentRoute: typeof BareOauthConsentRoute
  BareTaxFormTokenRoute: typeof BareTaxFormTokenRoute
}

const BareRouteChildren: BareRouteChildren = {
  BareForgotPasswordRoute: BareForgotPasswordRoute,
  BareResetPasswordRoute: BareResetPasswordRoute,
  BareSignInRoute: BareSignInRoute,
  BareSignUpRoute: BareSignUpRoute,
  BareVerifyEmailRoute: BareVerifyEmailRoute,
  BareVerifyPhoneRoute: BareVerifyPhoneRoute,
  BareDevAccountingPreviewRoute: BareDevAccountingPreviewRoute,
  BareDevCompanyDocumentsPreviewRoute: BareDevCompanyDocumentsPreviewRoute,
  BareDevDashboardPreviewRoute: BareDevDashboardPreviewRoute,
  BareDevEinApplicationPreviewRoute: BareDevEinApplicationPreviewRoute,
  BareDevFederalTaxListPreviewRoute: BareDevFederalTaxListPreviewRoute,
  BareDevFederalTaxSubmissionPreviewRoute:
    BareDevFederalTaxSubmissionPreviewRoute,
  BareDevFederalTaxWizardPreviewRoute: BareDevFederalTaxWizardPreviewRoute,
  BareDevMailroomPreviewRoute: BareDevMailroomPreviewRoute,
  BareDevOnboardingWizardPreviewRoute: BareDevOnboardingWizardPreviewRoute,
  BareDevOrdersPreviewRoute: BareDevOrdersPreviewRoute,
  BareDevPaymentSuccessPreviewRoute: BareDevPaymentSuccessPreviewRoute,
  BareDevPlatformStatusPreviewRoute: BareDevPlatformStatusPreviewRoute,
  BareDevRaChangePreviewRoute: BareDevRaChangePreviewRoute,
  BareDevServicesPreviewRoute: BareDevServicesPreviewRoute,
  BareDevShareholdersPreviewRoute: BareDevShareholdersPreviewRoute,
  BareDevShellPreviewRoute: BareDevShellPreviewRoute,
  BareDevSidebarDemoRoute: BareDevSidebarDemoRoute,
  BareDevStateFilingsPreviewRoute: BareDevStateFilingsPreviewRoute,
  BareDevUiKitRoute: BareDevUiKitRoute,
  BareOauthConsentRoute: BareOauthConsentRoute,
  BareTaxFormTokenRoute: BareTaxFormTokenRoute,
}

const BareRouteWithChildren = BareRoute._addFileChildren(BareRouteChildren)

interface ShellOnboardingRouteChildren {
  ShellOnboardingStepRoute: typeof ShellOnboardingStepRoute
  ShellOnboardingIndexRoute: typeof ShellOnboardingIndexRoute
}

const ShellOnboardingRouteChildren: ShellOnboardingRouteChildren = {
  ShellOnboardingStepRoute: ShellOnboardingStepRoute,
  ShellOnboardingIndexRoute: ShellOnboardingIndexRoute,
}

const ShellOnboardingRouteWithChildren = ShellOnboardingRoute._addFileChildren(
  ShellOnboardingRouteChildren,
)

interface ShellRouteChildren {
  ShellSplatRoute: typeof ShellSplatRoute
  ShellBankingRoute: typeof ShellBankingRoute
  ShellCompanyRoute: typeof ShellCompanyRoute
  ShellConnectionsRoute: typeof ShellConnectionsRoute
  ShellMailroomRoute: typeof ShellMailroomRoute
  ShellOnboardingRoute: typeof ShellOnboardingRouteWithChildren
  ShellOrdersRoute: typeof ShellOrdersRoute
  ShellPaymentSuccessRoute: typeof ShellPaymentSuccessRoute
  ShellServicesRoute: typeof ShellServicesRoute
  ShellIndexRoute: typeof ShellIndexRoute
  ShellAccountConnectedAgentsRoute: typeof ShellAccountConnectedAgentsRoute
  ShellAccountSecurityRoute: typeof ShellAccountSecurityRoute
  ShellAccountSettingsRoute: typeof ShellAccountSettingsRoute
  ShellAccountingConnectionsRoute: typeof ShellAccountingConnectionsRoute
  ShellAccountingContractorsRoute: typeof ShellAccountingContractorsRoute
  ShellAccountingDocumentsRoute: typeof ShellAccountingDocumentsRoute
  ShellAccountingGeneralLedgerRoute: typeof ShellAccountingGeneralLedgerRoute
  ShellAccountingQuestionsRoute: typeof ShellAccountingQuestionsRoute
  ShellAccountingReconciliationRoute: typeof ShellAccountingReconciliationRoute
  ShellAccountingReportsRoute: typeof ShellAccountingReportsRoute
  ShellAccountingTransactionsRoute: typeof ShellAccountingTransactionsRoute
  ShellFederalTaxIdRoute: typeof ShellFederalTaxIdRoute
  ShellStateFilingsCancelRoute: typeof ShellStateFilingsCancelRoute
  ShellStateFilingsSuccessRoute: typeof ShellStateFilingsSuccessRoute
  ShellStateTaxIdRoute: typeof ShellStateTaxIdRoute
  ShellStateTaxAnnualReportRoute: typeof ShellStateTaxAnnualReportRoute
  ShellStateTaxCancelRoute: typeof ShellStateTaxCancelRoute
  ShellStateTaxFranchiseTaxRoute: typeof ShellStateTaxFranchiseTaxRoute
  ShellStateTaxSuccessRoute: typeof ShellStateTaxSuccessRoute
  ShellAccountingIndexRoute: typeof ShellAccountingIndexRoute
  ShellEinCorrectionIndexRoute: typeof ShellEinCorrectionIndexRoute
  ShellFederalTaxIndexRoute: typeof ShellFederalTaxIndexRoute
  ShellStateFilingsIndexRoute: typeof ShellStateFilingsIndexRoute
  ShellStateTaxIndexRoute: typeof ShellStateTaxIndexRoute
  ShellAccountingAccountsAccountIdRoute: typeof ShellAccountingAccountsAccountIdRoute
  ShellRegisteredAgentChangeOrderIdRoute: typeof ShellRegisteredAgentChangeOrderIdRoute
  ShellStateFilingsOrdersIdRoute: typeof ShellStateFilingsOrdersIdRoute
  ShellAccountingAccountsIndexRoute: typeof ShellAccountingAccountsIndexRoute
  ShellAccountingConnectionsStripeCallbackRoute: typeof ShellAccountingConnectionsStripeCallbackRoute
}

const ShellRouteChildren: ShellRouteChildren = {
  ShellSplatRoute: ShellSplatRoute,
  ShellBankingRoute: ShellBankingRoute,
  ShellCompanyRoute: ShellCompanyRoute,
  ShellConnectionsRoute: ShellConnectionsRoute,
  ShellMailroomRoute: ShellMailroomRoute,
  ShellOnboardingRoute: ShellOnboardingRouteWithChildren,
  ShellOrdersRoute: ShellOrdersRoute,
  ShellPaymentSuccessRoute: ShellPaymentSuccessRoute,
  ShellServicesRoute: ShellServicesRoute,
  ShellIndexRoute: ShellIndexRoute,
  ShellAccountConnectedAgentsRoute: ShellAccountConnectedAgentsRoute,
  ShellAccountSecurityRoute: ShellAccountSecurityRoute,
  ShellAccountSettingsRoute: ShellAccountSettingsRoute,
  ShellAccountingConnectionsRoute: ShellAccountingConnectionsRoute,
  ShellAccountingContractorsRoute: ShellAccountingContractorsRoute,
  ShellAccountingDocumentsRoute: ShellAccountingDocumentsRoute,
  ShellAccountingGeneralLedgerRoute: ShellAccountingGeneralLedgerRoute,
  ShellAccountingQuestionsRoute: ShellAccountingQuestionsRoute,
  ShellAccountingReconciliationRoute: ShellAccountingReconciliationRoute,
  ShellAccountingReportsRoute: ShellAccountingReportsRoute,
  ShellAccountingTransactionsRoute: ShellAccountingTransactionsRoute,
  ShellFederalTaxIdRoute: ShellFederalTaxIdRoute,
  ShellStateFilingsCancelRoute: ShellStateFilingsCancelRoute,
  ShellStateFilingsSuccessRoute: ShellStateFilingsSuccessRoute,
  ShellStateTaxIdRoute: ShellStateTaxIdRoute,
  ShellStateTaxAnnualReportRoute: ShellStateTaxAnnualReportRoute,
  ShellStateTaxCancelRoute: ShellStateTaxCancelRoute,
  ShellStateTaxFranchiseTaxRoute: ShellStateTaxFranchiseTaxRoute,
  ShellStateTaxSuccessRoute: ShellStateTaxSuccessRoute,
  ShellAccountingIndexRoute: ShellAccountingIndexRoute,
  ShellEinCorrectionIndexRoute: ShellEinCorrectionIndexRoute,
  ShellFederalTaxIndexRoute: ShellFederalTaxIndexRoute,
  ShellStateFilingsIndexRoute: ShellStateFilingsIndexRoute,
  ShellStateTaxIndexRoute: ShellStateTaxIndexRoute,
  ShellAccountingAccountsAccountIdRoute: ShellAccountingAccountsAccountIdRoute,
  ShellRegisteredAgentChangeOrderIdRoute:
    ShellRegisteredAgentChangeOrderIdRoute,
  ShellStateFilingsOrdersIdRoute: ShellStateFilingsOrdersIdRoute,
  ShellAccountingAccountsIndexRoute: ShellAccountingAccountsIndexRoute,
  ShellAccountingConnectionsStripeCallbackRoute:
    ShellAccountingConnectionsStripeCallbackRoute,
}

const ShellRouteWithChildren = ShellRoute._addFileChildren(ShellRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  BareRoute: BareRouteWithChildren,
  ShellRoute: ShellRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
